import { render } from "./FAQ2.vue?vue&type=template&id=71194008"
import script from "./FAQ2.vue?vue&type=script&lang=js"
export * from "./FAQ2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Functional/FAQ2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71194008"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71194008', __exports__)) {
    api.reload('71194008', __exports__)
  }
  
  module.hot.accept("./FAQ2.vue?vue&type=template&id=71194008", () => {
    api.rerender('71194008', render)
  })

}


export default __exports__